<template>
  <section class="toast-container">
    <div class="toast" :class="[visible ? 'fade-in' : 'fade-out']">
      <p>{{ msg }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ToastComp',
  data() {
    return {
      msg: '加载中...',
      visible: false
    }
  }
}
</script>

<style lang="less" scoped>
  @import './Toast.less';
</style>
